import { httpClient } from './httpClient';

const base = '/api/formaciones';

export const listarFormaciones = (params = {}) => {
  const entries = Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '' && v !== 'all');
  const qs = new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString();
  return httpClient.get(`${base}${qs ? `?${qs}` : ''}`);
};
export const listarFormacionesPorEstudiante = (estudianteId) =>
  httpClient.get(`${base}/estudiante/${estudianteId}`);
export const crearFormacion = (payload) => httpClient.post(base, payload);
export const obtenerHistorialFormacion = (id) => httpClient.get(`${base}/${id}/historial`);
export const actualizarFormacion = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarFormacion = (id) => httpClient.del(`${base}/${id}`);

const formacionesService = {
  listar: listarFormaciones,
  listarPorEstudiante: listarFormacionesPorEstudiante,
  crear: crearFormacion,
  historial: obtenerHistorialFormacion,
  actualizar: actualizarFormacion,
  eliminar: eliminarFormacion,
};

export default formacionesService;
